import { ComponentIds, Entity, OutlinedComponent } from '@inter-ikea-core/core';
import {
  CoreApi,
  Product,
  NonMarketProduct,
  isOfType,
  PlannerProductComponent,
  getProductReferenceFor,
  getProduct,
  ProductInfoComponent,
  ShoppingBagComponent,
  InteriorComponent,
  HideFromAssemblyInstructionsComponent,
  isUnavailableProduct,
  UnavailableProductComponent,
  isProductPart,
  OuterMeasurementsComponent,
  AssemblyInstructionsComponent,
  HideInSeeThroughSystemComponent,
  DistanceMeasurementComponent,
  NonDeletableComponent,
  NonDuplicatableComponent,
  ProductType
} from '@inter-ikea-storageone/range';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';

export const ladmakareComponentResolver = (
  coreApi: CoreApi,
  products: Product[],
  unavailableProducts: Product[],
  productsNotInMarket: NonMarketProduct[],
  coreSpecificProducts: NonMarketProduct[]
) => {
  const isShoppingProduct = isOfType([
    ProductType.LADMAKARE_PANEL,
    ProductType.LADMAKARE_CABINET,
    ProductType.LADMAKARE_SHELF,
    ProductType.LADMAKARE_COMPARTMENT
  ]);

  //Should include all product types that should added to the scene
  const isPlannerProduct = isOfType([
    ProductType.LADMAKARE_SECTION_WITH_SHELVES,
    ProductType.LADMAKARE_SECTION,
    ProductType.LADMAKARE_CABINET,
    ProductType.LADMAKARE_SHELF,
    ProductType.LADMAKARE_COMPARTMENT
  ]);

  const shouldBeIncludedInOuterMeasurement = isOfType([ProductType.LADMAKARE_PANEL]);

  const isSection = isOfType([ProductType.LADMAKARE_SECTION]);
  const isShelf = isOfType([ProductType.LADMAKARE_SHELF]);

  const isInterior = isOfType([
    ProductType.LADMAKARE_CABINET,
    ProductType.LADMAKARE_SHELF,
    ProductType.LADMAKARE_COMPARTMENT
  ]);

  const shouldBeRemovedFromAssemblyImages = isOfType([]);
  const shouldHaveAssemblyInstructions = isOfType([ProductType.LADMAKARE_SECTION]);

  const componentBuilder = {
    build: (entity: Entity) => {
      const product = getProduct(entity, [
        ...products,
        ...unavailableProducts,
        ...productsNotInMarket,
        ...coreSpecificProducts
      ]);

      if (product) {
        entity.addComponent(
          new ProductInfoComponent(product.globalItemNo, product.name, product.type, product.design)
        );
      }

      if (entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
        entity.addComponent(new HideInSeeThroughSystemComponent());
      }

      if (shouldBeIncludedInOuterMeasurement(entity)) {
        entity.addComponent(new OuterMeasurementsComponent());
      }

      if (isUnavailableProduct(entity, unavailableProducts) && !isProductPart(entity)) {
        entity.addComponent(new UnavailableProductComponent());
        entity.addComponent(new OutlinedComponent());
        entity.removeComponent(ComponentIds.SELECTABLE_COMPONENT_ID);
      }

      if (shouldHaveAssemblyInstructions(entity)) {
        entity.addComponent(new AssemblyInstructionsComponent());
      }

      if (isPlannerProduct(entity)) {
        entity.addComponent(new PlannerProductComponent(getProductReferenceFor(entity)));
      }

      if (isShoppingProduct(entity)) {
        entity.addComponent(new ShoppingBagComponent(getProductReferenceFor(entity)));
      }
      if (isInterior(entity)) {
        entity.addComponent(new InteriorComponent());
        entity.addComponent(
          new DistanceMeasurementComponent([Direction.UP, Direction.DOWN], [Direction.UP])
        );
      }

      if (isSection(entity)) {
        entity.addComponent(new DistanceMeasurementComponent([Direction.RIGHT, Direction.LEFT]));
      }
      if (shouldBeRemovedFromAssemblyImages(entity)) {
        entity.addComponent(new HideFromAssemblyInstructionsComponent());
      }
      if (isShelf(entity)) {
        entity.addComponent(new NonDeletableComponent());
        entity.addComponent(new NonDuplicatableComponent());
      }
    }
  };
  return {
    resolveComponentBuilder: () => componentBuilder
  };
};
